import { Box, Group, Text } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import { permissionsApi } from '@/api/permissions'
import type { UserRow } from './UsersTable'
import { buildAccessSummary } from './accessSummary'

/** Faixa read-only "Resumo de acesso" (C7) no topo do UserDrawer. Reusa a query
 *  ['user-permissions', id] (mesma key do UserDrawerPermissions → cache). */
export function AccessSummary({ user }: { user: UserRow }) {
  const { data: perms } = useQuery({
    queryKey: ['user-permissions', user.id],
    queryFn: () => permissionsApi.getUserPermissions(user.id),
  })
  const s = buildAccessSummary(user, perms)
  const items: [string, string][] = [
    ['Função', s.funcao],
    ['Perfil global', s.perfilGlobal],
    ['Escopo de tenants', s.escopoTenants],
    ['Org de contexto', s.orgContexto],
  ]
  return (
    <Box px="md" py="xs" style={{ borderBottom: '1px solid var(--mantine-color-default-border)' }}>
      <Text size="xs" fw={700} tt="uppercase" c="dimmed" style={{ letterSpacing: '0.06em' }} mb={4}>
        Resumo de acesso
      </Text>
      <Group gap="xl">
        {items.map(([label, value]) => (
          <Box key={label}>
            <Text size="xs" c="dimmed">{label}</Text>
            <Text size="sm" fw={500}>{value}</Text>
          </Box>
        ))}
      </Group>
    </Box>
  )
}
